<template>
  <section>
    <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapsed=!collapsed">
      <h2>{{ $t("lang.msg.technicalDataAndQuality") }}</h2>
        <span :class="{'toggled':collapsed}">▲</span>
    </div>
    <div class="bg-white p-4 md:p-8 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 xl:gap-4" v-if="collapsed">
      <div class="space-y-4">
        <InputWrapper :label="$t('lang.msg.tissue')">
          {{ getLangValue(data, 'tissue') }}
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.composition')">
          {{ getLangValue(data, 'compositionList') }}
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.quality')">
          {{ getLangValue(data, 'quality') }}
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.weight')">
          {{ getLangValue(data, 'weight') }}
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.title')">
          {{ getLangValue(data, 'tittle') }}
        </InputWrapper>
      </div>

      <div class="space-y-4">
        <InputWrapper :label="$t('lang.msg.lu')">
          {{ getLangValue(data, 'lu') }}
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.galga')">
          {{ getLangValue(data, 'hound') }}
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.refinements')">
          {{ getLangValue(data, 'finishList') }}
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.confectionDetails')">
          {{ getLangValue(data, 'makingList') }}
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.mainPrint')">
          {{ getLangValue(data, 'printList') }}
        </InputWrapper>
      </div>

      <div class="space-y-4">
        <InputWrapper :label="$t('lang.msg.mainComplement')">
          {{ getLangValue(data, 'complementList') }}
        </InputWrapper>
        <!-- =========================== -->
        <!-- === TECHNICAL DATA SLOT === -->
        <!-- =========================== -->
        <slot />
        <div class="grid grid-cols-2">
          <div />
          <ButtonRedirect route="technicalSheet" :params="{ idDesign: idDesign }">
            {{ $t("lang.msg.technicalSheet") }}
          </ButtonRedirect>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TechnicalData",
  props: {
    idDesign: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      data: [],
        collapsed :true
    };
  },
  created() {
    if (this.idDesign != 0) {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      this.$axios
        .post(`api/DataSheets/GetMain`, {
          idDesign: parseInt(this.idDesign)
        })
        .then(response => {
          this.data = response.data[0];
        });
    }
  },
  watch: {
    idDesign() {
      this.fetchData();
    }
  }
};
</script>
